export const routes = (prefix = `inventory-management`) => [
    {
        path: `/${prefix}/orders`,
        name: `${prefix}.orders.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.orders.index`,
                PageDescription: "Inventory management: Orders",
            },
        },
    },
    {
        path: `/${prefix}/orders/create`,
        name: `${prefix}.orders.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.orders.index`,
                PageDescription: "Inventory management: Orders",
            },
        },
    },
    {
        path: `/${prefix}/orders/print/:orderNo`,
        name: `${prefix}.orders.print`,
        component: () => import('./prints/Order.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.orders.index`,
                PageDescription: "Inventory management: Orders",
            },
        },
    },  {
        path: `/${prefix}/orders/printTransfer/:transferCode`,
        name: `${prefix}.orders.print`,
        component: () => import('./prints/Transfer.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.orders.index`,
                PageDescription: "Inventory management: Transfer",
            },
        },
    },
];
